<template>
	<div class="relative px-2">
		<div class="main f fx fcc" style="height: 60px;">
			<img src="../assets/logo_x.png" style="height: 30px;" />
			<div class="f-1"></div>
			<div v-if="$i18n.locale=='en-US'" class="relative ff2 f14 f fx fcc hm bolder"
				@click="switchLanguage('ja-JP')">
				<span style="color: #8e8783;">JP/</span>EN
			</div>
			<div v-else class="relative ff2 f14 f fx fcc hm bolder" @click="switchLanguage('en-US')">
				JP<span style="color: #8e8783;">/EN</span>
			</div>
		</div>

	</div>


</template>

<script>
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		data() {
			return {

			}
		},
		methods: {

			logout() {

				this.setLogout();
				this.$router.push('/login')
			},



			
		}
	}
</script>

<style scoped>

</style>